<template>
    <div>
        <el-dialog title="货运" :visible="showDialog" width="800" @close="closeDialog()">
            <el-form
                :model="youzhicaiOrderFreight"
                ref="orderDelivery"
                label-width="120px"
                :inline="true"
                size="small"
                :rules="rules"
            >
                <el-form-item
                    label="是否分批"
                    prop="isPartLogistic"
                >
                    <el-select
                        placeholder="请选择是否分批发货"
                        disabled
                        style="width: 200px"
                        v-model="youzhicaiOrderFreight.isPartLogistic"
                    >
                        <el-option
                            v-for="(item,index) in yesNoEnumList"
                            :key="index"
                            :label="item.value"
                            :value="item.key"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="配送类型"
                    prop="deliveryType"
                >
                    <el-select
                        placeholder="请选择配送类型"
                        style="width: 200px"
                        v-model="youzhicaiOrderFreight.deliveryType"
                        @change="deliveryTypeChange"
                    >
                        <el-option
                            v-for="(item,index) in deliveryTypeEnumList"
                            :key="index"
                            :label="item.value"
                            :value="item.key"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="配送人名"
                    prop="deliveryMan"
                    v-if="youzhicaiOrderFreight.deliveryType == 1"
                >
                    <el-input
                        style="width: 200px"
                        size="small"
                        placeholder="请输入配送人姓名"
                        v-model="youzhicaiOrderFreight.deliveryMan"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="配送电话"
                    prop="contactTel"
                    v-if="youzhicaiOrderFreight.deliveryType == 1"
                >
                    <el-input
                        style="width: 200px"
                        size="small"
                        placeholder="请输入配送人电话"
                        v-model="youzhicaiOrderFreight.contactTel"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="发货时间"
                    prop="deliveryTime"
                    v-if="youzhicaiOrderFreight.deliveryType == 1"
                >
                    <el-date-picker
                        style="width: 200px"
                        v-model="youzhicaiOrderFreight.deliveryTime"
                        type="datetime"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item
                    label="到货时间"
                    prop="arrivalTime"
                    v-if="youzhicaiOrderFreight.deliveryType == 1"
                >
                    <el-date-picker
                        style="width: 200px"
                        v-model="youzhicaiOrderFreight.arrivalTime"
                        type="datetime"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item
                    label="物流公司代码"
                    prop="logisticsCode"
                    v-if="youzhicaiOrderFreight.deliveryType == 2"
                >
                    <el-select
                        size="small"
                        v-model="youzhicaiOrderFreight.logisticsCode"
                    >
                        <el-option
                            v-for="(item,index) in logisticsTypeEnumList"
                            :key="index"
                            :label="item.value"
                            :value="item.code"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="物流单号"
                    prop="logisticsNum"
                    v-if="youzhicaiOrderFreight.deliveryType == 2"
                >
                    <el-input
                        style="width: 200px"
                        size="small"
                        placeholder="请输入物流单号"
                        v-model="youzhicaiOrderFreight.logisticsNum"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="发货备注"
                    prop="remark"
                >
                    <el-input
                        style="width: 200px"
                        type="textarea"
                        :rows="2"
                        size="small"
                        placeholder="请输入发货备注"
                        v-model="youzhicaiOrderFreight.remark"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog()">取 消</el-button>
                <el-button type="primary" @click="onSubmit()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { get } from '@/utils/request.js';
export default {
    props:{
        showDialog:{
            type: Boolean,
            default: false
        },
        youzhicaiOrder:{
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            yesNoEnumList: [],
            deliveryTypeEnumList: [],
            logisticsTypeEnumList: [],

            youzhicaiOrderFreight: {
                orderId: "",
                orderCode: "",
                isPartLogistic: "",
                partOrderId: "",
                deliveryType: "",
                deliveryMan: "",
                contactTel: "",
                deliveryTime: "",
                arrivalTime: "",
                logisticsCode: "",
                logisticsNum: "",
                remark: "",
            },
            rules: {
                isPartLogistic: [{ required: true, message: '是否分批发货不能为空', trigger: 'blur' }],
                deliveryType: [{ required: true, message: '配送类型不能为空', trigger: 'blur' }],
                deliveryMan: [{ required: true, message: '配送人姓名不能为空', trigger: 'blur' }],
                contactTel: [{ required: true, message: '配送人电话不能为空', trigger: 'blur' }],
                deliveryTime: [{ required: true, message: '发货时间不能为空', trigger: 'blur' }],
                arrivalTime: [{ required: true, message: '预计到货时间不能为空', trigger: 'blur' }],
                logisticsCode: [{ required: true, message: '物流公司代码不能为空', trigger: 'blur' }],
                logisticsNum: [{ required: true, message: '物流单号代码不能为空', trigger: 'blur' }],
            },
        }
    },
    created() {
        this.getYesNoEnum();
        this.getDeliveryTypeEnum();
        this.getLogisticsTypeEnum();
    },
    watch:{
        youzhicaiOrder:{
            handler(newVlaue){
                this.youzhicaiOrderFreight.orderId = newVlaue.id
                this.youzhicaiOrderFreight.orderCode = newVlaue.orderCode
                this.youzhicaiOrderFreight.isPartLogistic = newVlaue.isPartOrder
                console.log("newVlaue.isPartOrder",newVlaue)
            },
            deep: true
        },
    },
    methods: {
        closeDialog(){
            this.$emit("closeFreightDialog")
        },
        onSubmit(){
            get("/youzhicai/order/addFreight",{...this.youzhicaiOrderFreight}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    this.closeDialog()
                    this.$emit("resetDialog")
                    this.$emit("closeFreightDialog")
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            })
        },

        // 获取yes_no枚举
        getYesNoEnum() {
            get("/mpp/utils/getEnum", {
                enumType: 'yes_no'
            }).then((res) => {
                if (res.success) {
                    this.yesNoEnumList = res.enumList;
                }
            });
        },

        // 获取DeliveryType枚举
        getDeliveryTypeEnum(){
            get("/youzhicai/utils/getEnum",{
                enumType: 'delivery_type_enum'
            }).then((res)=>{
                if(res.success){
                    this.deliveryTypeEnumList = res.enumList;
                }
            })
        },

        deliveryTypeChange(){
                this.youzhicaiOrderFreight.deliveryMan = ""
                this.youzhicaiOrderFreight.contactTel = ""
                this.youzhicaiOrderFreight.deliveryTime = ""
                this.youzhicaiOrderFreight.arrivalTime = ""
                this.youzhicaiOrderFreight.logisticsCode = ""
                this.youzhicaiOrderFreight.logisticsNum = ""
                this.youzhicaiOrderFreight.remark = ""
        },



        // 获取快递枚举
        getLogisticsTypeEnum(){
            get('/mpp/utils/getEnum', {
                enumType: 'logistics_type_enum'
            }).then((res) => {
                if (res.success) {
                    this.logisticsTypeEnumList = res.enumList;
                }
            });
        },
    }
};
</script>
<style lang="scss" scoped>

</style>